import React, { useState, useEffect } from "react"
import { ApiCheckUserMenuAccess, ApiGetIncomeList, ApiPrintIncomeStatus } from "utils/constants/api";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, MenuIncProjectId, PageSize
    , PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext 
 } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import useFetch from "utils/hooks/useFetch";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import SearchButton from "components/Button/SearchButton";
import PdfGenerator from '../../../components/modal/components/PdfGenerator';
import PaginationButton from "components/Input/PaginationButton";
import { RoundTwoDecimals } from "utils/helpers";
import { useNavigate } from "react-router-dom";

export default function Income(){
    let navigate = useNavigate()

    const { data: incomeList, fetch: getIncomeList } = useFetch(ApiGetIncomeList)
    const { data: printStatus, fetch: getPrintStatus } = useFetch(ApiPrintIncomeStatus)
    const { fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    const [projectLocation, setProjectLocation] = useState(EmptyString)
    const [clientName, setClientName] = useState(EmptyString)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // User Menu Access
    const [allowPrint, setAllowPrint] = useState(false)

    useEffect(() => {
        setLoading({isOpen: true})
        fCheckUserAccess(localStorage.getItem("Id"), MenuIncProjectId, localStorage.getItem("CompanyId")).then((res) => {
            if(!res.access){
                navigate("/access-denied")
            }
            if(res.print){
                setAllowPrint(true)
            }
            searchBtnClick()
        })
    },[])

    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    async function searchBtnClick (){
        setLoading({isOpen: true})

        fSearchBtnClick(0).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, pageIndex)
            }
            setLoading({isOpen: false})
        })
    }
    
    async function fSearchBtnClick (index){
        let res 
        
        await getIncomeList({
            data: {
                projectLocation: projectLocation,
                clientName: clientName,
                companyId:  localStorage.getItem("CompanyId"),
                pageSize: PageSize,
                pageIndex: parseInt(index),
                status: 1,
                pageType: PageTypeGetPaged,
                sortBy: "A.CompanyName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
        
        return res
    }
    async function fPrintStatus (projectId, terminType){
        let res 
        
        await getPrintStatus({
            data: {
                projectId: projectId,
                terminType: terminType,
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }

    const generatePdf = async (data, type = 1) => {
        let typeName = "Termin 1";
        let terminValue = data.termin1
        if (type == 2){
            typeName = "Termin 2";
            terminValue = data.termin2
        }
        if (type == 3){
            typeName = "Termin 3";
            terminValue = data.termin3
        }
        if (type == 4){
            typeName = "Termin 4";
            terminValue = data.termin4
        }
        if (type == 5){
            typeName = "Termin 5";
            terminValue = data.termin5
        }
        
        const totalPaid = data.comfee + 
            (data.isPrintedTermin1 && type > 1 ? data.termin1 : 0) +
            (data.isPrintedTermin2 && type > 2 ? data.termin2 : 0) +
            (data.isPrintedTermin3 && type > 3 ? data.termin3 : 0) +
            (data.isPrintedTermin4 && type > 4 ? data.termin4 : 0) +
            (data.isPrintedTermin5 && type > 5 ? data.termin5 : 0);

        const vendorData = {
            type: type,
            typeName: typeName,
            terminValue: terminValue,
            termin1: data.termin1,
            termin2: data.termin2,
            termin3: data.termin3,
            termin4: data.termin4,
            termin5: data.termin5,
            clientName: data.clientName,
            bankName: data.bankName,
            accountNumber: data.accountNumber,
            companyName: localStorage.getItem("CompanyName"),
            comfee: data.comfee,
            projectLocation: data.projectLocation,
            furnitureSellingPrice: data.furnitureSellingPrice,
            isPrintedTermin1: data.isPrintedTermin1,
            isPrintedTermin2: data.isPrintedTermin2,
            isPrintedTermin3: data.isPrintedTermin3,
            isPrintedTermin4: data.isPrintedTermin4,
            totalPaid: totalPaid,
            address: data.address,
            city: data.city
        };
        PdfGenerator({ vendorData });

        await fPrintStatus(data.projectId, type).then(() => {
			setLoading(false)
		})
        await searchBtnClick()
    }
    
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fSearchBtnClick(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fSearchBtnClick(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fSearchBtnClick(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fSearchBtnClick(index)
        }
    }

    function fPaginationIndexChange(index){
        setPageIndex(index)
        fSearchBtnClick(index)
    }

    return(
        <div className="flex flex-col gap-2">
             <div>
                <span className="font-semibold text-2xl">Income</span>
            </div>
            <hr />

            <div className="mt-5 flex flex-wrap justify-between">
                <div className="flex flex-wrap gap-5">
                    <div className="flex flex-col gap-2 w-72">
                        <span>Client Name</span>
                        <input className="input" value={clientName} onChange={(e) => { setClientName(e.target.value) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-72">
                        <span>Project Location</span>
                        <input className="input" value={projectLocation} onChange={(e) => { setProjectLocation(e.target.value) }} />
                    </div>
                </div>
                <div className="flex items-end">
                    <SearchButton onClick={() => { searchBtnClick() }} />
                </div>
            </div>

            <div className="mt-5 overflow-auto">
                <table className="w-[1400px] 2xl:w-full border overflow-auto bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold w-32 text-left px-2">Client Name</th>
                            <th className="font-semibold w-56 text-left px-2">Project Location</th>
                            <th className="font-semibold w-48 text-center px-2">Nilai Kontrak</th>
                            <th className="font-semibold w-48 text-center px-2">Termin 1</th>
                            <th className="font-semibold w-48 text-center px-2">Termin 2</th>
                            <th className="font-semibold w-48 text-center px-2">Termin 3</th>
                            <th className="font-semibold w-48 text-center px-2">Termin 4</th>
                            <th className="font-semibold w-48 text-center px-2">Termin 5</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { incomeList?.data?.listData.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y" key={i}>
                                    <td className="text-center">{i + 1}</td>
                                    <td className="px-2">
                                        <span>{ data?.clientName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data?.projectLocation }</span>
                                    </td>
                                    <td className="px-2 text-right">
                                        <span>
                                            Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.totalSellingPrice || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin1 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "cursor-pointer") : ""}`}
                                        onClick={() => allowPrint ? (data?.isPrintedTermin1 ? (localStorage.getItem("IsAdmin") === "1" ? generatePdf(data, 1) : EmptyString) : generatePdf(data, 1)) : EmptyString}
                                    >
                                        <span className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin1 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "text-blue-500 cursor-pointer") : "cursor-default"}`}>
                                            Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.termin1 || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin2 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "cursor-pointer") : "cursor-default"}`}
                                        onClick={() => allowPrint ? (data?.isPrintedTermin2 ? (localStorage.getItem("IsAdmin") === "1" ? generatePdf(data, 2) : EmptyString) :generatePdf(data, 2)) : EmptyString}
                                    >
                                        <span className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin2 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "text-blue-500 cursor-pointer") : "cursor-default"}`}>
                                            Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.termin2 || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin3 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "cursor-pointer") : "cursor-default"}`}
                                        onClick={() => allowPrint ? (data?.isPrintedTermin3 ? (localStorage.getItem("IsAdmin") === "1" ? generatePdf(data, 3) : EmptyString) : generatePdf(data, 3)) : EmptyString}
                                    >
                                        <span className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin3 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "text-blue-500 cursor-pointer") : "cursor-default"}`}>
                                        Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.termin3 || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin4 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "cursor-pointer") : "cursor-default"}`}
                                        onClick={() => allowPrint ? (data?.isPrintedTermin4 ? (localStorage.getItem("IsAdmin") === "1" ? generatePdf(data, 4) : EmptyString) : generatePdf(data, 4)) : EmptyString}
                                    >
                                        <span className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin4 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "text-blue-500 cursor-pointer") : "cursor-default"}`}>
                                        Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.termin4 || 0)) }
                                        </span>
                                    </td>
                                    <td className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin5 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "cursor-pointer") : "cursor-default"}`}
                                        onClick={() => allowPrint ? (data?.isPrintedTermin5 ? (localStorage.getItem("IsAdmin") === "1" ? generatePdf(data, 5) : EmptyString) : generatePdf(data, 5)) : EmptyString}
                                    >
                                        <span className={`px-2 text-right ${allowPrint ? (data?.isPrintedTermin5 ? (localStorage.getItem("IsAdmin") === "1" ? "text-black-500 cursor-pointer" : "text-black-500 cursor-not-allowed") : "text-blue-500 cursor-pointer") : "cursor-default"}`}>
                                        Rp { new Intl.NumberFormat().format(RoundTwoDecimals(data?.termin5 || 0)) }
                                        </span>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}